export default __webpack_public_path__ + "static/media/pitch.08b004a5.svg";